import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import badgeSlotRecipe from './badge.recipe'
import {Box, useSlotRecipe} from '@chakra-ui/react3'

const Badge = ({text, variant, colorWorld}) => {
    const recipe = useSlotRecipe({recipe: badgeSlotRecipe})
    const styles = useMemo(() => recipe({variant, colorWorld}), [recipe, variant, colorWorld])
    return (
        <Box data-testid="badge" css={styles.badge}>
            {text}
        </Box>
    )
}

Badge.displayName = 'Badge'

Badge.propTypes = {
    text: PropTypes.string.isRequired,
    variant: PropTypes.string,
    colorWorld: PropTypes.string
}

export default Badge
